import { StoreProviderFilterHelper } from "src/app/shared/helpers/store-provider-filter.helper";
import { ProviderGetDTO } from "../providers/provider.model";
import { StoreGetDTO } from "../store-management/stores/store";
import {
  DashboardFilter,
  toDashboardApiQueryParams,
} from "./models/filter.model";

export interface DashboardFilterFormValue {
  provider: string;
  store: string;
  startDate: string;
  endDate: string;
}

export function buildDashboardFilterFromContext(
  contextData: { filterForm?: DashboardFilterFormValue } | undefined,
  defaultRange: { startDate: string; endDate: string },
  stores: StoreGetDTO[],
  providers: ProviderGetDTO[],
): DashboardFilter {
  const form = contextData?.filterForm;
  const startDate = form?.startDate ?? defaultRange.startDate;
  const endDate = form?.endDate ?? defaultRange.endDate;

  const { provider, storeId } =
    StoreProviderFilterHelper.buildStoreProviderApiParams(
      form?.store ?? "",
      form?.provider ?? "",
      stores,
      providers,
      { allowAllProviders: true },
    );

  return toDashboardApiQueryParams({
    startDate: normalizeDashboardDate(startDate),
    endDate: normalizeDashboardDate(endDate),
    storeId: storeId ?? "",
    provider,
  });
}

function normalizeDashboardDate(value: string): string {
  if (!value) {
    return value;
  }

  return value.includes("T") ? value.split("T")[0] : value;
}
